import { render, staticRenderFns } from "./InfosGameTop.vue?vue&type=template&id=7a477234"
import script from "./InfosGameTop.vue?vue&type=script&lang=js"
export * from "./InfosGameTop.vue?vue&type=script&lang=js"
import style0 from "./InfosGameTop.vue?vue&type=style&index=0&id=7a477234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports